export default "__VITE_ASSET__312f7392__"